export const AUTH_TYPES = {
    login: '[AUTH] login',
    logout: '[AUTH] logout',
};